import type { ice } from '@halvard/rules';
import { useEffect } from 'react';
import type { IceGameStoreApi } from '../game/ice/store';
import { startIceBotDriver } from './iceDriver';
import type { IceBotResponse } from './iceProtocol';

/** Plays the ice bots' turns with a Web Worker, so the board never freezes while a bot thinks. */
export function useIceBotDriver(store: IceGameStoreApi, seed: number): void {
  useEffect(() => {
    const worker = new Worker(new URL('./iceBot.worker.ts', import.meta.url), { type: 'module' });
    const pending = new Map<number, (response: IceBotResponse) => void>();
    let nextId = 0;
    worker.onmessage = (event: MessageEvent<IceBotResponse>) => {
      pending.get(event.data.id)?.(event.data);
      pending.delete(event.data.id);
    };
    const stop = startIceBotDriver(
      store,
      (request) =>
        new Promise<ice.IceAction>((resolve, reject) => {
          const id = nextId++;
          pending.set(id, (response) => {
            if (response.ok) resolve(response.choice);
            else reject(new Error(response.error));
          });
          worker.postMessage({ ...request, id });
        }),
      { seed },
    );
    return () => {
      stop();
      worker.terminate();
    };
  }, [store, seed]);
}
